import { render, staticRenderFns } from "./DeceasedDialog.vue?vue&type=template&id=05d5054e"
import script from "./DeceasedDialog.vue?vue&type=script&lang=js"
export * from "./DeceasedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports